import { render, staticRenderFns } from "./inputfile.vue?vue&type=template&id=2484a1fc&"
import script from "./inputfile.js?vue&type=script&lang=js&"
export * from "./inputfile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2484a1fc')) {
      api.createRecord('2484a1fc', component.options)
    } else {
      api.reload('2484a1fc', component.options)
    }
    module.hot.accept("./inputfile.vue?vue&type=template&id=2484a1fc&", function () {
      api.rerender('2484a1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/inputfile.vue"
export default component.exports